import React from 'react';
import moment from 'moment';

const RangeFilter = ({ filterHandler }) => {
  const minRef = React.useRef(null)
  const maxRef = React.useRef(null)

  const handleChange = () => {
    if (!minRef.current.value && !maxRef.current.value) {
      filterHandler();
    } else {
      filterHandler({ callback: isFiltered });
    }
  }

  const isFiltered = (targetValue) => {
    let formattedMin;
    let formattedMax;
    let formattedTarget = new Date(targetValue.props.children).getTime();

    if (minRef.current.value && !maxRef.current.value) {
      formattedMin = new Date(moment(minRef.current.value).set({h: 0, m: 0, s: 0})).getTime();

      return formattedTarget >= new Date(moment(minRef.current.value).set({h: 0, m: 0, s: 0})).getTime();
    }

    if (!minRef.current.value && maxRef.current.value) {
      formattedMax = new Date(moment(maxRef.current.value).set({h: 23, m: 59, s: 59})).getTime();

      return formattedTarget <= formattedMax;
    }

    if (minRef.current.value && maxRef.current.value) {
      formattedMin = new Date(moment(minRef.current.value).set({h: 0, m: 0, s: 0})).getTime();
      formattedMax = new Date(moment(maxRef.current.value).set({h: 23, m: 59, s: 59})).getTime();

      return formattedTarget >= formattedMin && formattedTarget <= formattedMax;
    }
  }

  return (
    <div style={{ borderColor: 'red' }}>
      <input ref={minRef} type="date" className="rangefilter" onChange={handleChange} placeholder="start" />
      <input ref={maxRef} type="date" className="rangefilter" style={{ position: 'relative', left: '4%' }} onChange={handleChange} placeholder="end" />
    </div>
  );
};

export default RangeFilter;
